import Pagination from "react-bootstrap/Pagination";

interface PropsData {
  totalCount: number;
  itemCountPerPage: number;
  changePage: (page: number) => void;
  currentPage: number;
}

const PrimePagination = ({
  totalCount,
  itemCountPerPage,
  changePage,
  currentPage,
}: PropsData) => {
  const totalPage = Math.ceil(totalCount / itemCountPerPage);
  const maxVisiblePages = 5;

  let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
  let endPage = Math.min(totalPage, startPage + maxVisiblePages - 1);

  if (endPage - startPage < maxVisiblePages - 1) {
    startPage = Math.max(1, endPage - maxVisiblePages + 1);
  }
  console.log(currentPage,"currepage");
  

  return (
    <Pagination>
      <Pagination.First
        disabled={currentPage === 1}
        onClick={() => changePage(1)}
      />
      <Pagination.Prev
        disabled={currentPage === 1}
        onClick={() => changePage(currentPage - 1)}
      />
      {[...Array(endPage - startPage + 1)].map((_, index) => (
        <Pagination.Item
          key={startPage + index}
          active={currentPage === startPage + index}
          onClick={() => changePage(startPage + index)}
        >
          {startPage + index}
        </Pagination.Item>
      ))}
      <Pagination.Next
        disabled={currentPage === totalPage}
        onClick={() => changePage(currentPage + 1)}
      />
      <Pagination.Last
        disabled={currentPage === totalPage}
        onClick={() => changePage(totalPage)}
      />
    </Pagination>
  );
};

export default PrimePagination;
